export default [
  {
    path: 'canonical-exercises',
    name: 'canonical-exercises',
    component: () =>
      import(
        /* webpackChunkName: "canonical-exercises" */ '@/views/CanonicalExercises'
      ),
  },
  {
    path: 'canonical-exercises/similar',
    name: 'similar-canonical-exercises',
    component: () =>
      import(
        /* webpackChunkName: "similar-canonical-exercises" */ '@/views/CanonicalExercises/Similar'
      ),
  },
  {
    path: 'canonical-exercises/:id',
    name: 'canonical-exercise',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "canonical-exercise-detail" */ '@/views/CanonicalExercises/Detail'
      ),
  },
]
